import { Mapper } from "../../../../base/utils/mapper";
import { ProcedureResponseModel } from "../../../../domain/models/consult/procedure-response.model";
import { ProcedureResponseEntity } from "../entities/procedure-response.entity";

export class ProcedureImplementationRepositoryMapper extends Mapper<ProcedureResponseEntity, ProcedureResponseModel> {
    mapFrom(param: ProcedureResponseEntity): ProcedureResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ProcedureResponseModel): ProcedureResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}